import React, { ComponentProps, ReactElement } from 'react';

import { CSSObject } from 'styled-components';

import LoadMoreData from '@adsk/alloy-react-load-more-data';

const LoadMoreMenuItems = ({
  style = {},
  ...props
}: ComponentProps<typeof LoadMoreData>): ReactElement => {
  return (
    <LoadMoreData
      style={{
        height: 40,
        justifyContent: 'center',
        ...(style as CSSObject),
      }}
      {...props}
    />
  );
};

LoadMoreMenuItems.propTypes = LoadMoreData.propTypes;

export default LoadMoreMenuItems;
